import React, { useEffect } from 'react'
import { useReactiveVar } from '@apollo/client'
import { growl } from '@wmgtech/legato'

import { GrowlAlertMessage } from 'components'
import { activeProjectVar, showArchivedGrowlVar } from 'modulesCommon/store'

export const useShowArchivedGrowl = () => {
  const activeProject = useReactiveVar(activeProjectVar)
  const showArchivedGrowl = useReactiveVar(showArchivedGrowlVar)
  
  useEffect(() => {
    if (showArchivedGrowl) {
      growl.success(
        {
          message: (
            <GrowlAlertMessage
              title="Success"
              message={
                <>
                  <b>{activeProject.name}</b> has been {activeProject.active ? 'activated' : 'archived'} successfully.
                </>
              }
            />
          ),
          containerStyle: 'tint',
          icon: 'check'
        },
        { toastId: 'archived-growl' }
      )
    }

    return () => {
      showArchivedGrowlVar(false)
    }
  }, [activeProject, showArchivedGrowl])
}
